import React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import Search from  './Search';

export default (WrappedComponent) => {
  class withSearch extends React.Component {
    state = {
      showSearch: false
    };

    showSearch = () => {
      this.setState({ showSearch: true });
    };

    hideSearch = () => {
      this.setState({ showSearch: false });
    };

    render() {
      return (
        <div
          className={'search-wrapper'}
        >
          <WrappedComponent {...this.props} showSearch={this.showSearch}/>
          {
            this.state.showSearch &&
            <Search onHide={this.hideSearch}/>
          }
        </div>
      )
    }
  }

  hoistNonReactStatic(withSearch, WrappedComponent);

  return withSearch;
}